import { httpDelete, patch, post } from '../../utils/http';

export const createOrderChange = ({ accountId, orderId, data, sessionNumber }) =>
  post(`/accounts/${accountId}/orders/${orderId}/changes`, { ...data, sessionNumber });

export const approveOrderChange = ({ accountId, orderId, applyChangesOnShifts, applyChangesOnOrders, sessionNumber }) =>
  patch(`/accounts/${accountId}/orders/${orderId}/changes`, {
    applyChangesOnShifts,
    applyChangesOnOrders,
    sessionNumber
  });

export const publishOrder = ({ accountId, orderId }) =>
  patch(`/accounts/${accountId}/orders/${orderId}/changes/publish`);

export const rejectOrderChange = ({ accountId, orderId, data, sessionNumber }) =>
  httpDelete(`/accounts/${accountId}/orders/${orderId}/changes`, { ...data, sessionNumber });
